//@flow
import React from 'react';
import MediaQuery from 'react-responsive/src/Component';
import { useViewport } from 'components/templates/viewportProvider';
import VisionPhilosophy from 'components/organisms/vision&Philosophy';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import { CallToAction } from 'components/atoms/callToAction';
//eslint-disable next-line
import './styles.scss';

type Props = {
  showButton?: boolean,
};

const VisionPhilosophySection = (props: Props) => {
  const { height } = useViewport();
  const {
    visionPhilosophySection: { visionSectionMobile },
    type,
  } = props.data;
  const { data } = props;

  return (
    <div
      id={
        type === 'architecture' ? 'design-philosophy' : 'vision-and-philosophy'
      }
    >
      <MediaQuery maxDeviceWidth={575.6}>
        <div className={'vision-section-mobile-view'} style={{ height }}>
          <div className={'inner-section'}>
            <div className={'heading-section'}>
              <h2>VISION & PHILOSOPHY</h2>
            </div>
            <div className={'carousel-module'}>
              <HorizontalCarousel
                data={visionSectionMobile}
                type={'visionSectionMobile'}
              />
            </div>
            {/*<CallToAction*/}
            {/*  text={'LEARN MORE'}*/}
            {/*  onClick={() => {}}*/}
            {/*  mode={'transparent'}*/}
            {/*  className={'vision-button'}*/}
            {/*/>*/}
          </div>
        </div>
      </MediaQuery>
      <MediaQuery minDeviceWidth={576}>
        <VisionPhilosophy type={type} data={data} />
      </MediaQuery>
    </div>
  );
};

export default VisionPhilosophySection;
